var DEBUG=false;
if (DEBUG) {
    console.info('App Js Run');
}